/* eslint-disable */
import schema from '@bingads-webui-static-legacy/wunderbar/data/schemas/new/AdGroup';
import backbone_schema from '@bingads-webui-static-legacy/wunderbar/libs/int/schema/factory/backbone';
export default {
  name: 'adgroup',
  backbone: backbone_schema.from(schema),
  schema: schema
};

